import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import getFileExtension from "@insite/client-framework/Common/Utilities/getFileExtension";
import siteMessage from "@insite/client-framework/SiteMessage";
import clearForm from "@insite/client-framework/Store/Components/ContactUsForm/Handlers/ClearForm";
import setIsBadFile from "@insite/client-framework/Store/Components/OrderUpload/Handlers/SetIsBadFile";
import setUploadLimitExceeded from "@insite/client-framework/Store/Components/OrderUpload/Handlers/SetUploadLimitExceeded";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Button, { ButtonPresentationProps } from "@insite/mobius/Button";
import FileUpload, { FileUploadPresentationProps } from "@insite/mobius/FileUpload";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import GridContainer, { GridContainerProps, GridOffset } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import AlertTriangle from "@insite/mobius/Icons/AlertTriangle";
import { SelectPresentationProps } from "@insite/mobius/Select";
import TextField, { TextFieldPresentationProps } from "@insite/mobius/TextField";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { formatPhoneNumber } from "@tFissco/Common/Utilities/formatPhoneNumber";
import { CallbackType, ErrorObjectType, InputObjectType, validate } from "@tFissco/Common/Utilities/validate";
import {
    careerFormValidatorConfig,
    FormErrorsStateType,
    intialErrorFormState,
    ValidatorConfigType,
} from "@tFissco/Components/CareerFormValidatorConfig";
import submitCareerForm from "@tFissco/Handlers/CareerFormHandler";
import * as React from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";

const enum fields {
    branch = "branch",
    jobTitle = "jobTitle",
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.branch]: string;
        [fields.jobTitle]: string;
    };
}

const enum fields {
    label = "label",
    hintText = "hintText",
    isRequired = "isRequired",
    selectLocation = "selectLocation",
}
const mapDispatchToProps = {
    submitCareerForm,
};

type Props = OwnProps & ResolveThunks<typeof mapDispatchToProps>;

export interface CareerStyles {
    formWrapper?: InjectableCss;
    mainGridContainer?: GridContainerProps;
    fullWidth?: InjectableCss;
    submitGridItem?: GridItemProps;
    submitButton?: ButtonPresentationProps;
    emailTextField?: TextFieldPresentationProps;
    CareerFormSectionwrapper?: GridContainerProps;
    CareerFormTitleWrapper?: GridItemProps;
    CareerFormSectionTitle?: TypographyProps;
    CareerFormSectionTitleValue?: TypographyProps;
    userGridContainer?: GridItemProps;
    branchGridContainer?: GridItemProps;
    creatAccountfileldLayout?: GridItemProps;
    titleOne: TypographyProps;
    titleTwo: TypographyProps;
    selectDropdown: SelectPresentationProps;
    fileuploadStyle?: InjectableCss;
    fileUploadWrapper?: InjectableCss;
    fileUploadHint?: InjectableCss;
    fileUploader?: FileUploadPresentationProps;
    documentUploadNote?: TypographyProps;
    documentUploadNoteTitle?: TypographyProps;
}

export const careerStyles: CareerStyles = {
    formWrapper: {
        css: css`
            margin-top: 20px;
            margin-bottom: 20px;
            h4 {
                font-weight: 600;
            }
            .fullWidthForMobileDevices {
                > div {
                    ${({ theme }: { theme: BaseTheme }) =>
                        breakpointMediaQueries(
                            theme,
                            [
                                null,
                                null,
                                css`
                                    width: 100% !important;
                                `,
                            ],
                            "max",
                        )}
                }
            }
            > div[class^="GridWrapper"] {
                margin-top: 10px;
                padding-left: 0;
                > div[class^="GridOffset"] {
                    width: 100%;
                    margin: 0;
                }
                > div[class^="RadioStyle"] {
                    margin-top: 0;
                    border: 1px solid red;
                    > label[class^="TypographyStyle"] {
                        font-size: 13px;
                    }
                }
            }
        `,
    },
    fullWidth: {
        css: css`
            width: 100%;
            > div[class^="RadioGroupStyle"] {
                justify-content: flex-start;
                display: inline-block;
                > div[class^="RadioStyle"] {
                    margin-top: 0;
                    margin-right: 20px;
                    display: inline-block;
                    &:last-child {
                        margin-right: 0;
                    }
                    > label[class^="TypographyStyle"] {
                        font-size: 13px;
                    }
                }
            }
        `,
    },
    submitGridItem: {
        width: 12,
        css: css`
            display: flex;
            justify-content: left;
            width: 100%;
            margin-block: 25px;
            flex-direction: column;
            gap: 30px;
        `,
    },
    submitButton: {
        css: css`
            margin-right: 10px;
            width: max-content;
        `,
    },
    CareerFormSectionwrapper: {
        css: css`
            background-color: ${getColor("secondary")};
            margin-bottom: 20px;
            border-radius: 10px;
            overflow: hidden;
            > ${GridOffset} {
                width: 100%;
                margin: 0px;
            }
        `,
    },
    CareerFormTitleWrapper: {
        width: 12,
        css: css`
            background: ${getColor("common.border")};
            padding: 11px 30px;
            border-top-left-radius: 10px;
            border-top-right-radius: 10px;
        `,
    },
    CareerFormSectionTitle: {
        variant: "h5",
        css: css`
            margin-bottom: 0;
            font-family: "MontserratRegular";
            color: ${getColor("text.accent")};
            font-weight: 700 !important;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        font-size: 16px;
                    `,
                    css`
                        font-size: 16px;
                    `,
                    css`
                        font-size: 16px;
                    `,
                    css``,
                    null,
                ])}
        `,
    },
    CareerFormSectionTitleValue: {
        variant: "h5",
        css: css`
            margin-bottom: 0;
            font-family: "MontserratRegular";
            color: ${getColor("text.accent")};
            font-weight: 100 !important;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        font-size: 16px;
                    `,
                    css`
                        font-size: 16px;
                    `,
                    css`
                        font-size: 16px;
                    `,
                    css``,
                    null,
                ])}
        `,
    },
    userGridContainer: {
        width: [12, 12, 12, 12, 12],
        css: css`
            flex-wrap: wrap;
            display: flex;
            padding-top: 0rem;
        `,
    },
    branchGridContainer: {
        width: [12, 12, 12, 12, 12],
        css: css`
            flex-wrap: wrap;
            padding: 24px 30px 0px;
            display: flex;
        `,
    },
    creatAccountfileldLayout: {
        width: [12, 12, 6, 6, 4],
    },
    titleOne: {
        variant: "headerSecondary",
        size: 14,
        transform: "none",
        color: "text.accent",
        css: css`
            font-family: "MontserratMedium" !important;
            font-weight: 400;
            line-height: 1.5 !important;
        `,
    },
    titleTwo: {
        variant: "headerSecondary",
        size: 14,
        transform: "none",
        color: "text.accent",
        css: css`
            margin: 2rem 0rem;
            font-family: "MontserratMedium" !important;
            font-weight: 600;
            line-height: 1.5 !important;
        `,
    },
    selectDropdown: {
        cssOverrides: {
            formField: css`
                width: 100%;
            `,
        },
    },
    fileUploadWrapper: {
        css: css`
            display: flex;
            align-items: flex-start;
            flex-direction: column;
            width: 100%;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        null,
                        null,
                        css`
                            display: block;
                        `,
                    ],
                    "max",
                )}
        `,
    },
    fileUploadHint: {
        css: css`
            font-size: 12px;
            display: flex;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        flex-direction: column;
                    `,
                    css`
                        flex-direction: column;
                    `,
                    null,
                    null,
                    null,
                ])}
        `,
    },
    fileuploadStyle: {
        css: css`
            position: relative;
            width: 50%;
            margin-right: 10px;
            margin-top: 10px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        null,
                        null,
                        css`
                            width: 100%;
                            margin-right: 0px;
                            margin-bottom: 10px;
                        `,
                    ],
                    "max",
                )}
            >div[class^="UploadWrapper"] {
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(
                        theme,
                        [
                            css`
                                display: block;
                                > label[class^="ButtonWrapper"] {
                                    margin: 5px 0 0 0;
                                }
                            `,
                        ],
                        "max",
                    )}
            }
            > span[class^="TypographyStyle"] {
                position: absolute;
                left: 100px;
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(
                        theme,
                        [
                            null,
                            null,
                            css`
                                position: relative;
                                left: 0;
                            `,
                        ],
                        "max",
                    )}
                font-size: 13px;
                padding-top: 4px;
            }
        `,
    },
    fileUploader: {
        buttonProps: {
            variant: "primary",
            css: css`
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(
                        theme,
                        [
                            css`
                                margin-left: 0;
                            `,
                            css`
                                margin-left: 0;
                            `,
                            null,
                            null,
                            null,
                        ],
                        "max",
                    )}
            `,
        },
    },
    documentUploadNote: {
        as: "p",
        css: css`
            margin: 10px 10px 0px 0px;
            font-size: 14px;
        `,
    },
    documentUploadNoteTitle: {
        css: css`
            display: inline-block;
            font-weight: 600;
        `,
    },
};

const styles = careerStyles;
const emailRequiredFieldMessage = siteMessage("CreateNewAccountInfo_EmailAddress_Required");
const emailFieldMessage = siteMessage("CreateNewAccountInfo_EmailAddress_ValidEmail");
const emailRegexp = new RegExp("\\w+([-+.']\\w+)*@\\w+([-.]\\w+)*\\.\\w+([-.]\\w+)*");

const CareerForm = ({ submitCareerForm, fields }: Props) => {
    const [isloading, setIsLoading] = React.useState(false);
    const [firstName, setFirstName] = React.useState("");
    const [lastName, setLastName] = React.useState("");
    const [phone, setphone] = React.useState("");
    const [isSubmitted, setIsSubmitted] = React.useState(false);
    const [emailError, setEmailError] = React.useState(emailRequiredFieldMessage);
    const [emailAddress, setEmail] = React.useState("");
    const [formErrors, setFormErrors] = React.useState<FormErrorsStateType>(intialErrorFormState);
    const fileUploadRef = React.useRef({ value: "" } as HTMLInputElement);
    const [file, setFile] = React.useState<any>(null);
    const [fileErrorMsg, setFileErrorMsg] = React.useState("");

    const [isButtonDisabled, setIsButtonDisabled] = React.useState(true);
    const firstNameChangeHandler = (input: HTMLInputElement) => {
        setFirstName(input.value);
        validateHandler(input);
    };
    const lastNameChangeHandler = (input: HTMLInputElement) => {
        setLastName(input.value);
        validateHandler(input);
    };

    const phoneChangeHandler = (input: HTMLInputElement) => {
        setphone(formatPhoneNumber(input.value));
        validateHandler(input);
    };
    const emailChangeHandler = (input: HTMLInputElement) => {
        validateEmail(input.value);
        setEmail(input.value);
        validateHandler(input);
    };
    const validateEmail = (email: string) => {
        const errorMessage = !email ? emailRequiredFieldMessage : emailRegexp.test(email) ? "" : emailFieldMessage;
        setEmailError(errorMessage);
        return !errorMessage;
    };

    const validateHandler = (
        input: HTMLInputElement | HTMLSelectElement | any,
        customValidation?: CallbackType,
    ): void => {
        const inputObject: InputObjectType = {
            name: input.name,
            value: input.value,
        };
        const validatorConfig = careerFormValidatorConfig[input.name as keyof ValidatorConfigType];
        const isValidate: ErrorObjectType | undefined = validate(inputObject, validatorConfig, customValidation);

        if (isValidate === undefined) {
            delete formErrors[input.name as keyof FormErrorsStateType];
            setFormErrors(formErrors);
        } else {
            setFormErrors({
                ...formErrors,
                [input.name]: isValidate ? isValidate.errorMsg : isValidate,
            });
        }
        if (!validatorConfig.required && input.value === "") {
            delete formErrors[input.name as keyof FormErrorsStateType];
            setFormErrors(formErrors);
        }
        scrollToFirstFormError();
        setIsButtonDisabled(validateSubmitDisabled(formErrors));
    };
    const scrollToFirstFormError = () => {
        const firstErrorElement = document.querySelector("[data-test-selector='undefined-error']");
        if (firstErrorElement) {
            const formFieldParent = firstErrorElement.closest("[class*='FormFieldStyle']");
            if (!formFieldParent) {
                return;
            }
            const { top } = formFieldParent.getBoundingClientRect();
            window.scrollTo({
                top: top + window.pageYOffset - 250,
                left: 0,
                behavior: "smooth",
            });
        }
    };
    const validateSubmitDisabled = (errorsState: FormErrorsStateType) => {
        return Object.keys(errorsState).length !== 0;
    };
    const submitHandler = () => {
        if (!isSubmitted) {
            setIsSubmitted(true);
            setIsLoading(true);
            submitCareerForm({
                phone,
                firstName,
                lastName,
                branch: fields.branch,
                jobTitle: fields.jobTitle,
                emailAddress,
                attachment: file,
                onSuccess: () => {
                    clearForm();
                    window.location.href = "/ThankYou";
                },
            });
        }
    };

    const validateSelectedFile = (
        uploadedFileSize: { size: number },
        callback: { (value: React.SetStateAction<string>): void; (arg0: string): void },
    ) => {
        const MAX_FILE_SIZE = 5120; // 5MB
        const fileSizeKiloBytes = uploadedFileSize.size / 1024;
        const maxSize = fileSizeKiloBytes > MAX_FILE_SIZE;
        if (maxSize) {
            callback("File size is greater than maximum limit");
        }
    };

    const fileChangeHandler = (event: React.ChangeEvent<any>) => {
        const uploadedFile = event.target.files[0];
        setFile(uploadedFile);
        setFileErrorMsg("");
        if (uploadedFile) {
            const fileExtension = getFileExtension(uploadedFile.name);
            const incorrectFileExtension =
                ["xls", "xlsx", "csv", "png", "jpg", "docx", "doc", "pdf"].indexOf(fileExtension) === -1;
            if (incorrectFileExtension) {
                setFileErrorMsg("Invalid file format");
                return;
            }
            // setIncorrectFileExtension(incorrectFileExtension);
            setIsBadFile({ isBadFile: incorrectFileExtension });
            setUploadLimitExceeded({ uploadLimitExceeded: false });
            validateSelectedFile(uploadedFile, setFileErrorMsg);
        }
    };

    return (
        <StyledWrapper {...styles.formWrapper}>
            <GridContainer {...styles.mainGridContainer}>
                <StyledWrapper {...styles.fullWidth}>
                    <form autoComplete="off">
                        <GridContainer {...styles.CareerFormSectionwrapper}>
                            <GridItem {...styles.CareerFormTitleWrapper}>
                                <Typography {...styles.CareerFormSectionTitle}>Apply Today!</Typography>
                            </GridItem>
                            <GridItem {...styles.branchGridContainer}>
                                <Typography {...styles.CareerFormSectionTitle}>Branch:</Typography>
                                <Typography {...styles.CareerFormSectionTitleValue}>&nbsp;{fields.branch}</Typography>
                            </GridItem>
                            <GridItem {...styles.userGridContainer}>
                                <GridItem {...styles.creatAccountfileldLayout}>
                                    <TextField
                                        {...styles.emailTextField}
                                        type="email"
                                        label={translate("Email ID")}
                                        value={emailAddress}
                                        data-test-selector="career_email"
                                        onChange={e => emailChangeHandler(e.currentTarget)}
                                        onBlur={e => validateHandler(e.currentTarget)}
                                        error={!!formErrors.emailAddress && formErrors.emailAddress}
                                        name="emailAddress"
                                        iconProps={{
                                            color: "danger",
                                            src: formErrors.emailAddress ? AlertTriangle : undefined,
                                        }}
                                        required
                                    />
                                </GridItem>
                                <GridItem {...styles.creatAccountfileldLayout}>
                                    <TextField
                                        label={translate("First Name")}
                                        value={firstName}
                                        data-test-selector="career_firstName"
                                        onChange={e => firstNameChangeHandler(e.currentTarget)}
                                        onBlur={e => validateHandler(e.currentTarget)}
                                        error={!!formErrors.firstName && formErrors.firstName}
                                        name="firstName"
                                        iconProps={{
                                            color: "danger",
                                            src: formErrors.firstName ? AlertTriangle : undefined,
                                        }}
                                        required
                                    />
                                </GridItem>
                                <GridItem {...styles.creatAccountfileldLayout}>
                                    <TextField
                                        label={translate("Last Name")}
                                        value={lastName}
                                        data-test-selector="career_lastName"
                                        onChange={e => lastNameChangeHandler(e.currentTarget)}
                                        onBlur={e => validateHandler(e.currentTarget)}
                                        error={!!formErrors.lastName && formErrors.lastName}
                                        name="lastName"
                                        iconProps={{
                                            color: "danger",
                                            src: formErrors.lastName ? AlertTriangle : undefined,
                                        }}
                                        required
                                    />
                                </GridItem>
                                <GridItem {...styles.creatAccountfileldLayout}>
                                    <TextField
                                        label={translate("Phone Number")}
                                        type="tel"
                                        list="autocompleteOff"
                                        autoComplete="new-password"
                                        aria-autocomplete="none"
                                        value={phone}
                                        data-test-selector="career_phone"
                                        onChange={e => phoneChangeHandler(e.currentTarget)}
                                        onBlur={e => validateHandler(e.currentTarget)}
                                        error={!!formErrors.phone && formErrors.phone}
                                        name="phone"
                                        iconProps={{
                                            color: "danger",
                                            src: formErrors.phone ? AlertTriangle : undefined,
                                        }}
                                        required
                                    />
                                </GridItem>
                            </GridItem>
                        </GridContainer>
                    </form>
                </StyledWrapper>
            </GridContainer>
            <StyledWrapper {...styles.fileUploadWrapper}>
                <StyledWrapper {...styles.fileuploadStyle}>
                    <FileUpload
                        {...styles.fileUploader}
                        inputRef={fileUploadRef}
                        fileName={file?.name || ""}
                        accept=".xls,.xlsx,.csv,.docx,.doc,.pdf,.jpg,.png"
                        label={translate("Upload a Resume")}
                        data-test-selector="career_uploadAFile"
                        labelPosition="top"
                        error={fileErrorMsg}
                        onFileChange={fileChangeHandler}
                    />
                </StyledWrapper>
                <StyledWrapper {...styles.fileUploadHint}>
                    <Typography {...styles.documentUploadNote}>
                        <Typography {...styles.documentUploadNoteTitle}> Accepted file types: </Typography>
                        .xls, .xlsx, .csv, .docx, .doc, .pdf, .jpg, .png
                    </Typography>
                    <Typography {...styles.documentUploadNote}>
                        <Typography {...styles.documentUploadNoteTitle}> Max file size: </Typography> 5 MB.
                    </Typography>
                </StyledWrapper>
            </StyledWrapper>
            <StyledWrapper {...styles.submitGridItem}>
                <Button
                    {...styles.submitButton}
                    onClick={submitHandler}
                    disabled={isButtonDisabled || isloading}
                    data-test-selector="careerForm_SubmitButton"
                >
                    {translate("Submit")}
                </Button>
                <Typography> * Required Fields </Typography>
            </StyledWrapper>
        </StyledWrapper>
    );
};
const widgetModule: WidgetModule = {
    component: connect(null, mapDispatchToProps)(CareerForm),
    definition: {
        displayName: "Career Form",
        group: "Contact Us",
        icon: "FormField",
        fieldDefinitions: [
            {
                name: fields.branch,
                editorTemplate: "TextField",
                defaultValue: "",
                fieldType: "General",
                isRequired: true,
            },
            {
                name: fields.jobTitle,
                editorTemplate: "TextField",
                defaultValue: "",
                fieldType: "General",
                isRequired: true,
            },
        ],
    },
};
export default widgetModule;
